var Marker = require('../../lib/markers/marker.js');
var Copier = require('../../lib/markers/copier.js');
var Deletism = require('../../lib/markers/deletism.js');
var Undeletism = require('../../lib/markers/undeletism.js');

module.exports = function() {
    var marker = new Marker('awards');

    new Copier(marker);
    new Deletism(marker);
    new Undeletism(marker);

    $('.filtertron').filtertron('awards', {
        expander: '#filtertronExpander'
    });
};
